import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Input, Col, Select} from 'antd'
import FormModal from './FormModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import UPM from '../../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

@inject('roleManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
  }

  handleSearch = () => {
    const {roleManagementStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      roleManagementStore.onChangePageNo()
      roleManagementStore.onSearchRoleAction({
        name: fieldsValue.name,
        status: fieldsValue.status === 'Enable' ? true : fieldsValue.status === 'Disable' ? false : '',
      }, 1, PAGE_SIZE_DEFAULT)
    }).catch(err => {})
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {location, t} = this.props
    return (
      <div className="container">
        <Form ref={this.formRef} className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="name" label={t(`roleManagement.name`)}
                         rules={[{
                           message: `${t(`general.pleaseEnter`)} ${t(`roleManagement.name`)} ${t(`general.withoutSpecialChats`)}`,
                           pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                         }]}>
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="status" label={t(`roleManagement.status`)}>
                <Select placeholder={t(`general.pleaseEnter`)} allowClear>
                  <Select.Option key="Enable" value="Enable">Enable</Select.Option>
                  <Select.Option key="Disable" value="Disable">Disable</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} offset={4} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </div>
    )
  }
}

export default withTranslation()(SearchForm)
